import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {Link} from 'react-router-dom';
import logo from '../../logo.jpg';
import classes from './Header.module.css';
// import card from '../card.jpeg';
// import Search from '../Search/Search';
import Narbar from './Navbar';
import Card from '../ListProduct/Card/Card';
import queryString from 'query-string';
import Carousel from '../Carousel/Carousel';
import {itemTotal} from '../Cart/CartHelpers';


function MainHeader(props) {
    const [data, setData] = useState({
        categories: [],
        category: "",
        search: "",
        results: [],
        searched: false
    });

    const { categories, category, search, results, searched } = data;

    const handleChange = name =>event=>{
        setData({...data,searched:false,[name]:event.target.value});
    };
    const searchSubmit =(event)=>{
        event.preventDefault();
        const query = queryString.stringify({search:search||undefined,category:category});
        axios.get(`/products/search?${query}`)
        .then(pro=>{
            // console.log(pro.data.pro)
             setData({...data,results:pro.data.pro,searched:true});
            })
            .catch(err=>{
                console.log(err);
            })
        };
        const getCategories =()=>{
            axios.get('/categorys')
        .then(cats=>{
            return setData({...data,categories:cats.data.cates})
        }).catch(err=>{
            console.log(err);
        });
    };
    useEffect(()=>{
        getCategories();
    },[])
    
    const searchMessage = (searched,results=[]) => {
        if (searched && results.length > 0) {
            return `Found ${results.length} products`;
        }
        if (searched && results.length < 1) {
            return `No products found`;
        }
    };

    const searchResult=(results=[])=>(
        <div className="row">
            {results.map((prod,i)=>(
        <div  className="col-sm-3 mb-3">
                <Card key={i} product={prod}/>
         </div>
            ))}
         </div>
    )

    const header =()=>(
        <React.Fragment>

    <div className={`${classes.Container}`}>
        <div className={`mx-auto ${classes.Logo}`}>
        <Link to="/">
            <img style={{borderRadius:"50%"}} src={logo} alt="Nha thuoc Bich Thanh"/>
            <div style={{color:"white"}}>Nhà Thuốc Bích Thanh</div>
        </Link>
        </div>
        <div className="col-sm-6 col-md-6 col-xs-3 mx-auto">
            {/* search bar */}
            <form onSubmit={searchSubmit}>
            <span>
            <div className={` input-group input-group-lg`}>    
                <input
                    type="search"
                    className={` form-control`}
                    onChange={handleChange("search")}
                    placeholder="Tìm kiếm"
                    style={{ border: "none"}}
                />
                        <select
                           className={classes.Select}
                            onChange={handleChange("category")}
                            style={{ border: "none",textAlignLast: "right",outline:"none",fontSize:"12px"}}
                        >
                        <option value="All">Tất cả</option>
                            {categories.map((c, i) => (
                                <option  key={i} value={c._id}> {/*style={{ direction: "rtl" }}*/}
                                    {c.name}
                                </option>
                            ))}
                        </select>
                <div
                    className="input-group-append"
                    style={{ border: "none" }}
                >
                    <button className="btn btn-warning ">Tìm kiếm</button>
                </div>
            </div>
                
            </span>
        </form>

            {/* end search bar */}
        </div>
        <div className={`${classes.Cart} mx-auto`}>
            <Link to="/cart">
            <span className="mr-2">
                Giỏ Hàng
            </span>
            <i className="fas fa-shopping-cart "></i>
            {/* <span className={classes.Count}>
                0
            </span> */}
            <sup>
                <small className="badge badge-warning">
                    {itemTotal()}
                </small>
            </sup>
            </Link>
        </div>
        
    </div>
                </React.Fragment>
    )
    return (
        <React.Fragment>
            {header()}
             <Narbar/>
             <Carousel/>
             <div className="container-fluid" >
                 <br/>
                 <div className="row">
                    <div className="col-md-9">
                            <h2 className="mb-4">{searchMessage(searched,results)}</h2>
                                {searchResult(results)}          
                    </div>
                 </div>
             </div>
        </React.Fragment>
    );
}

export default MainHeader;